export const validateDeteccionMalezaData = (datosAnalisis) => ({
    areaPoligono: datosAnalisis.areaPoligono?.valor !== undefined,
    areaMaleza: datosAnalisis.areaMaleza?.valor !== undefined,
    porcentajeMaleza: datosAnalisis.porcentajeMaleza?.valor !== undefined
});